module.exports = __webpack_public_path__ + "images/iveco_smalle2b7540c2f5036187f4397ad0af8073c.png";